import projection from '../generated/pwg5m4f1.json';
import { AcceptanceManifest } from '../types';

export const pwg5m4f1AcceptanceManifest = projection as AcceptanceManifest;
